export default __webpack_public_path__ + "static/media/icon_list_24.6f649eef.svg";